/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetLedgerWithdrawRequestsBySelfOptions,
  GetLedgerWithdrawRequestsBySelfResponses,
} from '../types/GetLedgerWithdrawRequestsBySelf'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get all pending withdrawal requests for the logged in user
 * {@link /v1/ledger/withdraw/requests/self}
 */
export function getLedgerWithdrawRequestsBySelf<ThrowOnError extends boolean = true>(
  options: Options<GetLedgerWithdrawRequestsBySelfOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetLedgerWithdrawRequestsBySelfResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/ledger/withdraw/requests/self',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetLedgerWithdrawRequestsBySelfResponses, ThrowOnError>>,
  )
}
